module.exports = __webpack_public_path__ + "void-4c8270c17facce6d53726a2ebb9745f2.png";